module.exports = __webpack_public_path__ + "img/tangve-giftbox.56d91c5e.svg";